module.exports = __webpack_public_path__ + "static/media/vintage-frame.e0c35ec7.png";